/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FrameImageWork from './FrameImageWork';

export default class FrameArea extends Component {

	render() {
		const {wallcolor, canvasImage, rightFrameHeight} = this.props;
		//console.log(canvasImage)
		const styles = {
			wallColorBg: {backgroundColor: wallcolor, height: rightFrameHeight}
		};
		return (
			<div className="img_set_sec" style={styles.wallColorBg}>
				{/* <a href="#!" onClick={this.props.lgShowF}> */}
					<FrameImageWork
	    				{...this.props} />
				{/* </a> */}
				<Modal
					show={this.props.lgShow}
					onHide={this.props.lgClose}
					bsSize="large"
				>
					<Modal.Header closeButton>
			        	<Modal.Title id="contained-modal-title-lg">{this.props.selectedFrame.get('name')}</Modal.Title>
			        </Modal.Header>
					<Modal.Body>
						<div style={{ textAlign: 'center' }} className="popup-wrapper">
							<img src={canvasImage} alt={this.props.selectedFrame.get('name')} />
						</div>
					</Modal.Body>
				</Modal>
		    </div>
	    );
	}
}